export default __webpack_public_path__ + "assets/images/logo_3.216b43.webp";